export default __webpack_public_path__ + "cb9e7a0aebef30e9fb6d4abb13f30f87.jpg";